import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { HeaderAggDataResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useHeaderAggData = (type: "inf" | "bulk") => {
  return useQuery<any, AxiosError<any>, HeaderAggDataResponse>(
    ["header", "aggData", type],
    () =>
      axiosClient
        .get<HeaderAggDataResponse>(`/reports/headerAggData?type=${type}`)
        .then(({ data }) => data),
    {
      staleTime: Infinity,
    }
  );
};
